//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Libraries
import moment from 'moment'
moment.locale('pt-BR')

export default {
  nuxtI18n: {
    paths: {
      br: '/base-de-conhecimento/:section/:publication',
      en: '/knowledge-base/:section/:publication',
      es: '/base-de-conocimientos/:section/:publication'
    }
  },

  async asyncData({ $api, params }) {
    try {
      const { section: slugSection, publication: slugPublication } = params
      const { data: publicationItem } = await $api.knowledgeBase.publication(
        slugSection,
        slugPublication
      )
      const publication = publicationItem.publication
      const products_related = publication.related
      const product_related_en = publication.related_en
      const product_related_es = publication.related_es

      return {
        publication,
        products_related,
        product_related_en,
        product_related_es,
        slugSection
      }
    } catch (err) {
      $api.instance.handleResponseError(err)
    }
  },

  data() {
    return {
      slugSection: '',
      products_related: [],
      products_related_en: [],
      products_related_es: [],
      publication: {
        id: 1,
        title:
          'Capítulo II – Análise mecânica dos materiais nos ensaios de: Geraldo R. de Almeida(MSc - DSc) Revista "O Setor Elétrico" Ed. 152 (Set 2018)',
        slug: 'capitulo-ii-analise-mecanica-dos-materiais-nos-ensaios-de-geraldo-r-de-almeidamsc-dsc-revista-o-setor-eletrico-ed-152-set-2018',
        date: '2021-03-15T03:00:00.000Z',
        text: `<p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis vel risus sit amet justo laoreet pharetra. Vestibulum dictum turpis eget rhoncus hendrerit. Nunc vehicula urna et elit varius, eu ultrices dolor ullamcorper. Integer ullamcorper dui nec urna finibus, eget rhoncus odio dapibus. Sed egestas enim laoreet odio scelerisque vulputate. Nam vestibulum velit in fringilla elementum. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur a purus sed ante <a href="#!">maximus ultricies.</a>
        </p>

        <img src="https://i.ibb.co/98r42Dm/1.jpg" />

        <p>
          Sed sed lacus vitae eros tristique pulvinar. Ut porttitor mauris ligula, in eleifend purus consequat a. Fusce vel purus eu massa pellentesque euismod. Nunc maximus fermentum tempor. In ut ornare nisi. Etiam ac tellus vitae magna dapibus posuere at a nisl. Etiam pretium quis sapien vel lobortis. Sed viverra velit ut sem rhoncus, vitae faucibus elit condimentum. Nam ut ornare ipsum. Interdum et malesuada fames ac ante ipsum primis in faucibus.
        </p>

        <p>
          Pellentesque in sagittis mi, et dictum massa. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Morbi consectetur hendrerit ante, at dapibus felis consequat vel. Cras venenatis nunc sit amet nisi fringilla fermentum. Suspendisse condimentum rutrum nisl nec eleifend. Fusce laoreet faucibus vestibulum. Suspendisse sit amet efficitur risus, id interdum augue. Vestibulum fermentum sed tortor nec suscipit. Sed mattis tempor eros, sed pretium justo vestibulum vitae. Duis porta euismod leo quis rutrum. Curabitur vitae volutpat urna. Nam ligula nisl, varius sit amet mattis et, semper eu magna. Fusce dignissim, nulla at rhoncus consequat, libero mauris viverra eros, vel ullamcorper elit diam a felis. Nulla non quam mi. Etiam et massa leo. Nullam nec condimentum ante.
        </p>

        <img src="https://i.ibb.co/VVgFD2v/2.jpg" />

        <p>
          Sed sed lacus vitae eros tristique pulvinar. Ut porttitor mauris ligula, in eleifend purus consequat a. Fusce vel purus eu massa pellentesque euismod. Nunc maximus fermentum tempor. In ut ornare nisi. Etiam ac tellus vitae magna dapibus posuere at a nisl. Etiam pretium quis sapien vel lobortis. Sed viverra velit ut sem rhoncus, vitae faucibus elit condimentum. Nam ut ornare ipsum. Interdum et malesuada fames ac ante ipsum primis in faucibus.
        </p>

        <p>
          Pellentesque in sagittis mi, et dictum massa. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Morbi consectetur hendrerit ante, at dapibus felis consequat vel. Cras venenatis nunc sit amet nisi fringilla fermentum. Suspendisse condimentum rutrum nisl nec eleifend. Fusce laoreet faucibus vestibulum. Suspendisse sit amet efficitur risus, id interdum augue. Vestibulum fermentum sed tortor nec suscipit. Sed mattis tempor eros, sed pretium justo vestibulum vitae. Duis porta euismod leo quis rutrum. Curabitur vitae volutpat urna. Nam ligula nisl, varius sit amet mattis et, semper eu magna. Fusce dignissim, nulla at rhoncus consequat, libero mauris viverra eros, vel ullamcorper elit diam a felis. Nulla non quam mi. Etiam et massa leo. Nullam nec condimentum ante.
        </p>
        `,
        section: {
          title: 'Catálogos',
          slug: 'catalogos'
        }
      }
    }
  },

  head() {
    const { title, seo } = this.publication

    return this.$helpers.seoBuilder(this, {
      staticTitle: seo ? seo.title : title || this.$t('title'),
      staticDescription: seo ? seo.description : null
    })
  },

  computed: {
    breadcrumbs() {
      const breadcrumbs = [
        {
          name: this.$t('home'),
          path: '/'
        },
        {
          name: this.$t('knowledge_base'),
          path: '/base-de-conhecimento'
        },
        {
          name: this.publication.section.title,
          path: `/base-de-conhecimento/${this.publication.section.slug}`
        },
        {
          name: this.publication.title,
          path: this.$route.fullPath
        }
      ]

      return breadcrumbs
    }
  },

  methods: {
    moment
  }
}
